import { COMMON } from "../../util/localizations"

const TRANSLATIONS = {
    en: {
        connections:  COMMON.en.connections,
        evidence: COMMON.en.evidence,
        implicatedParty:  COMMON.en.implicatedParty,
        inWallet: 'In Wallet',
        people:  COMMON.en.people
    }
}

export default TRANSLATIONS